module.exports = __webpack_public_path__ + "img/LITE_COIN.c01abd53.png";